import { z } from "zod";
/** A brand = a WhatsApp number under the shared WABA (architecture.md Multi-business). */
export const business = z.object({
    id: z.number().int().positive(),
    slug: z.string(),
    name: z.string(),
    phoneNumberId: z.string(),
    displayName: z.string(),
    tier: z.number().int(),
    quality: z.enum(["high", "medium", "low", "unknown"]),
    connected: z.boolean(),
});
export const businessListOutput = z.object({
    businesses: z.array(business),
});
//# sourceMappingURL=business.js.map